import { APIResponse } from 'types/Request';
import { getCookie } from 'helpers';
import config from 'config';
import { Delegations } from 'types/Delegations';

export async function getDelegations(): Promise<Delegations[]> {
  try {
    const url = new URL(`${ config.baseUrl }/delegations`);

    type Response = APIResponse<Delegations[]>

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: getCookie('accessToken'),
      },
    });

    if (response.status !== 200) {
      throw new Error('Ocurrió un problema de conexión al momento de intentar recuperar las delegaciones.');
    }

    const content = await response.json() as Response;

    if (content.status !== 'ok' || !content.payload) {
      throw new Error('Ocurrió un problema inesperado al momento de intentar recuperar las delegaciones.');
    }

    return content.payload;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
